import { Field, Form, Formik } from "formik";
import { IconButton, Typography, TypographyProps } from "@mui/material";
import { object, string } from "yup";
import { TextField } from "formik-mui";
import { useTranslation } from "react-i18next";
import EditIcon from "@mui/icons-material/ModeEditOutlined";
import React, { FunctionComponent, useState } from "react";
import SaveIcon from "@mui/icons-material/CheckOutlined";

interface Props extends TypographyProps {
  value: string;
  onEdit: (value: string) => void;
}

export const EditableTypography: FunctionComponent<Props> = ({
  value,
  onEdit,
  ...props
}) => {
  const [isEditing, setEditing] = useState<boolean>(false);
  const { t } = useTranslation();

  if (!isEditing) {
    return (
      <div className="flex items-center gap-4 min-w-0">
        <Typography
          {...props}
          className="text-ellipsis whitespace-nowrap overflow-hidden min-w-0"
        >
          {value}
        </Typography>
        <IconButton
          type="button"
          className="shrink-0"
          onClick={() => setEditing(true)}
          sx={{
            color: "text.secondary",
            "&:hover": { color: "text.primary" },
          }}
        >
          <EditIcon />
        </IconButton>
      </div>
    );
  }

  return (
    <Formik
      enableReinitialize
      initialValues={{
        name: value,
      }}
      validationSchema={object({
        name: string().required(t("utils.form.required")),
      })}
      onSubmit={(values) => {
        onEdit(values.name);
        setEditing(false);
      }}
    >
      {({ submitForm }) => (
        <Form className="flex items-center gap-4 min-w-0">
          <Field component={TextField} name="name" variant="outlined" />
          <IconButton
            type="button"
            color="secondary"
            className="shrink-0"
            onClick={submitForm}
          >
            <SaveIcon />
          </IconButton>
        </Form>
      )}
    </Formik>
  );
};
